// extracted by mini-css-extract-plugin
module.exports = {"container":"Links_container__3fFkf","title":"Links_title__bjWr0","button":"Links_button__yzflm","externalIcon":"Links_externalIcon__3LQos"};